<template>
  <div v-if="documents.length">
    <list-items-loadable v-slot="{ item }" :items="documents">
      <document-snippet-medium
        v-slot:before
        :document="item.document"
        :label="getSnippetLabel(item)"
        :format="item.openingFormat"
        :target="item.target"
      >
        <svg
          v-if="currentSectionIsPrivate"
          width="20"
          height="20"
          class="favorites__icon"
          @click="removeFromFavorites(item.document.id, item.id)"
        >
          <title>Удалить из избранного</title>
          <use xlink:href="#favorite" />
        </svg>
      </document-snippet-medium>
    </list-items-loadable>
  </div>
</template>

<script>

import DocumentSnippetMedium from '@@/shared/snippets/Snippet_Medium';
import ListItemsLoadable from '@@/shared/list/ListItemsLoadable';
import LoaderDots from '@@/shared/loaders/LoaderDots';

export default {
  components: {
    DocumentSnippetMedium,
    ListItemsLoadable,
    LoaderDots,
  },

  props: {
    documents: {
      type: Object,
      required: true
    },
    currentSectionIsPrivate: {
      type: Boolean,
      required: true
    }
  },

  methods: {
    async removeFromFavorites(documentId, favoriteId) {
      // В настоящее время здесь documentId не нужен, однако в будущем удаление из favorites должно идти по id документа
      await this.$store.dispatch('removeDocumentFromFavorites', {
        documentId: documentId,
        favoriteId: favoriteId
      });
      let indexItem = this.documents.findIndex(item => item.id === favoriteId);
      this.documents.splice(indexItem, 1);
    },
    getSnippetLabel(item) {
      // TODO: what is it?
      // return item.label !== item.document.title ? item.label : null;
    },
  },

  metaInfo: {
    title: 'Избранное'
  }
};
</script>
